<template>
  <div class="appResponsiveHeight">
    <v-app :dark="!!(isDark === 'dark')" id="inspire" :class="hideContainer ? 'register-container' : 'wrapper'">
      <v-app-bar app elevate-on-scroll elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
        class="custom-navbar" v-if="!$route.meta.noSidebar">
        <v-container class="fill-height app-bar-container">
          <v-app-bar-nav-icon class="d-md-none d-sm-flex d-xl-none d-lg-none"
            @click="drawer = !drawer"></v-app-bar-nav-icon>
          <DashboardView></DashboardView>
          <v-spacer></v-spacer>
          <PanelSwitcherView v-if="hasIbStatus"></PanelSwitcherView>
          <SignalsView></SignalsView>
          <LanguageMenu></LanguageMenu>
          <SwitcherView></SwitcherView>
          <NotificationView></NotificationView>
          <LogoutView></LogoutView>
        </v-container>
      </v-app-bar>
      <v-container :class="hideContainer ? 'register-container-fluid' : 'custom-container'">
        <v-row no-gutters>
          <v-col xl="2" class="custom-width-navigation-drawer" v-if="!$route.meta.noSidebar">
            <div class="navigation-drawer-container">
              <v-navigation-drawer v-model="drawer" :permanent="$vuetify.breakpoint.mdAndUp" width="240"
                class="navigation-drawer sidebar-navigation-drawer" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                <AdminLogo></AdminLogo>
                <AllMenu></AllMenu>
              </v-navigation-drawer>
            </div>
          </v-col>
          <v-col class="custom-width-main registration-page">
            <v-main>
              <router-view></router-view>
            </v-main>
          </v-col>
        </v-row>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import AdminLogo from "./components/SideBar/AdminLogo.vue";
import AllMenu from "./components/SideBar/AllMenu.vue";
import DashboardView from "./components/TopBar/DashboardView.vue";
import LanguageMenu from "./components/TopBar/LanguageMenu.vue";
import LogoutView from "./components/TopBar/LogoutView.vue";
import NotificationView from "./components/TopBar/NotificationView.vue";
import SignalsView from "./components/TopBar/SignalsView.vue";
import SwitcherView from "./components/TopBar/SwitcherView.vue";
import PanelSwitcherView from "./components/TopBar/PanelSwitcherView.vue";
export default {
  data() {
    return {
      drawer: null,
    };
  },
  components: {
    LanguageMenu,
    NotificationView,
    SignalsView,
    SwitcherView,
    DashboardView,
    LogoutView,
    AdminLogo,
    AllMenu,
    PanelSwitcherView
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    hideContainer() {
      return (
        this.$route.name === "/" ||
        this.$route.name === "Login" ||
        this.$route.name === "CreateAccount" ||
        this.$route.name === "Registration" ||
        this.$route.name === "SendOtp" ||
        this.$route.name === "ForgotPassword"
      );
    },
    hasIbStatus() {
      return this.$store.state.authentication.ib_status === 1;
    }
  },
};
</script>

<style scoped>
.appResponsiveHeight {
  height: 100vh;
  overflow-y: hidden;
  overflow-x: hidden;
}
</style>